import { useImmer } from 'use-immer';
import { useState } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import startCase from 'lodash/startCase';

export interface UseFormImmerOutput<T> {
    form: any;
    setForm: any;
    resetForm(): void;
    getInputProps(
        field: keyof T,
    ): {
        label: any;
        name: any;
        value: any;
        onChangeValue: any;
    };
    updateField(field: keyof T): (value: any) => void;
}

export function useFormImmer<T>(initial: T) {
    const [initialState] = useState(initial);
    const [form, setForm] = useImmer<T>(initial);

    return {
        form,
        setForm,
        resetForm() {
            setForm(() => cloneDeep(initialState));
        },
        updateField(field: keyof T) {
            return (value) => {
                setForm((form) => {
                    form[field as any] = value;
                });
            };
        },
        getInputProps(
            field: keyof T,
        ): {
            label: any;
            name: any;
            value: any;
            onChangeValue: any;
        } {
            return {
                label: startCase(field as any),
                name: field as any,
                value: form[field],
                onChangeValue(value) {
                    setForm((form) => {
                        form[field as any] = value;
                    });
                },
            };
        },
    };
}
